// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import IsleOfMan from '../_raw/flag/icon_flag_isle_of_man.png';

export default () => <img src={IsleOfMan} alt="IsleOfMan" />;
